import { Wallet, Receipt, Activity, UtensilsCrossed } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { usePoll } from "@/hooks/usePoll";
import { rp, METHOD_LABEL } from "@/lib/api";
import { StatCard, PageHeader, Panel } from "@/components/common";

export default function AdminDashboard() {
  const { data } = usePoll("/stats/admin", 15000);
  const d = data || { today_total: 0, today_count: 0, active_bills: 0, menu_count: 0, daily: [], top_items: [], by_method: {} };
  const chart = d.daily.map((x) => ({ ...x, label: new Date(x.date).toLocaleDateString("id-ID", { weekday: "short", day: "numeric" }) }));
  return (
    <div>
      <PageHeader title="Dashboard" subtitle="Ringkasan operasional hari ini" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <StatCard testId="stat-today-total" label="Pendapatan Hari Ini" value={rp(d.today_total)} icon={Wallet} />
        <StatCard testId="stat-today-count" label="Transaksi Lunas" value={d.today_count} icon={Receipt} accent="emerald" />
        <StatCard testId="stat-active-bills" label="Bill Berjalan" value={d.active_bills} icon={Activity} accent="amber" />
        <StatCard testId="stat-menu-count" label="Jumlah Menu" value={d.menu_count} icon={UtensilsCrossed} accent="stone" />
      </div>
      <div className="mt-6 grid grid-cols-1 gap-6 xl:grid-cols-3">
        <Panel className="p-5 xl:col-span-2">
          <h3 className="mb-4 text-lg font-semibold">Pendapatan 7 Hari Terakhir</h3>
          <div className="h-72" data-testid="chart-daily">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chart}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e7e5e4" vertical={false} />
                <XAxis dataKey="label" tick={{ fontSize: 12 }} />
                <YAxis tickFormatter={(v) => `${Math.round(v / 1000)}k`} tick={{ fontSize: 12 }} width={48} />
                <Tooltip formatter={(v) => rp(v)} />
                <Bar dataKey="total" fill="#EA580C" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Panel>
        <div className="space-y-6">
          <Panel className="p-5">
            <h3 className="mb-3 text-lg font-semibold">Menu Terlaris (7 hari)</h3>
            {d.top_items.length === 0 && <p className="text-sm text-zinc-500">Belum ada penjualan</p>}
            <ol className="space-y-2" data-testid="top-items">
              {d.top_items.map((t, i) => (
                <li key={t.name} className="flex items-center gap-3 text-sm">
                  <span className="grid h-6 w-6 place-items-center rounded-full bg-orange-100 text-xs font-bold text-orange-700">{i + 1}</span>
                  <span className="flex-1 truncate font-medium">{t.name}</span>
                  <span className="font-mono text-zinc-500">{t.qty}x</span>
                </li>
              ))}
            </ol>
          </Panel>
          <Panel className="p-5">
            <h3 className="mb-3 text-lg font-semibold">Metode Bayar Hari Ini</h3>
            <div className="space-y-2 text-sm">
              {Object.entries(d.by_method).map(([k, v]) => (
                <div key={k} className="flex justify-between"><span>{METHOD_LABEL[k]} ({v.count})</span><span className="font-mono">{rp(v.amount)}</span></div>
              ))}
            </div>
          </Panel>
        </div>
      </div>
    </div>
  );
}
